import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// components
import Toast from './Toast';
import { NotificationGroup } from '@progress/kendo-react-notification';
import { Slide } from '@progress/kendo-react-animation';
// store
import { getItems, removeToast } from 'src/slices/toast';
import { maxBy } from 'lodash';
// Styles
import './style.scss';
import { theme } from 'src/theme';

if (theme.mode === 'dark') {
  import(/* webpackChunkName: "dark" */ './style.scss?dark');
}

const ToastContainer = () => {
  const items = useSelector(getItems);
  const dispatch = useDispatch();

  const getItemId = (item) => {
    const { id, type } = item;

    const sameTypeToasts = items.filter((i) => i.type === type);
    const ind = sameTypeToasts.findIndex((i) => i.id === id);

    // If it is the first toast among the same type - don't use ind in id
    if (ind === 0) {
      return `toast-${type}`;
    }
    return `toast-${type}-${ind}`;
  };

  // if there is a success AND an error toast was there before, the error toast will be removed
  useEffect(() => {
    if (items.length > 1) {
      const bothErrorAndSuccess = items.some((i) => i.type === 'error') && items.some((i) => i.type === 'success');
      if (bothErrorAndSuccess) {
        const successes = items.filter((i) => i.type === 'success');
        const latestSuccess = maxBy(successes, 'id');
        // remove all errors which come BEFORE the latest success
        items.forEach((i) => {
          if (i.type === 'error' && i.id < latestSuccess.id) {
            dispatch(removeToast({ id: i.id }));
          }
        });
      }
    }
  }, [items, dispatch]);

  const onCloseHandler = ({ id }) => () => dispatch(removeToast({ id }));

  return (
    <NotificationGroup className='toast-group'>
      <Slide direction='up' className="k-list-scroller toast-list">
        {items.map((item) => (
          <span key={item.id} data-testid={getItemId(item)}>
            <Toast dataItem={item} onClose={onCloseHandler(item)} />
          </span>
        ))}
      </Slide>
    </NotificationGroup>
  );
};

export default ToastContainer;
